// ja strings for messages/paywall.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const paywall: Dict = {
  "paywall.hl.unlimitedCovers": "カバー作成が無制限",
  "paywall.hl.voices": "9.3万以上のボイス",
  "paywall.hl.downloads": "ダウンロード",
  "paywall.hl.duetsTts": "デュエットとテキスト読み上げ",
  "paywall.hl.trainVoices": "自分のボイスを学習",
  "paywall.hl.hdVideos": "1080pの動画",
  "paywall.hl.videoCoins": "毎月50枚の動画コイン",
  "paywall.hl.marbleLyric": "Marble Runと歌詞動画",
  "paywall.hl.priority": "優先処理",
  "paywall.hl.unlimitedCoins": "動画コインが無制限",
  "paywall.hl.apiCredits": "毎月$25分のAPIクレジット",
  "paywall.hl.everythingCreator": "Creatorの全機能",
  "paywall.hl.thisCover": "このカバーを今すぐ作成",

  "paywall.reason.unlock.title": "カバーのロックを解除",
  "paywall.reason.unlock.body":
    "ボイスと音声の準備はできています。登録するとすぐにカバーの作成が始まり、約1分で完成します。その後は好きなだけ作れます。",
  "paywall.reason.create.title": "カバーを作る準備ができました",
  "paywall.reason.create.body":
    "音声とボイスの設定は完了しています。プランを選んで作成しましょう。その後は好きなだけカバーを作れます。",
  "paywall.reason.browse.title": "好きな声でカバーを作ろう",
  "paywall.reason.browse.body":
    "カバー作成とダウンロードが無制限、9.3万以上のボイスがすべて使えます。いつでも解約できます。",
  "paywall.reason.credits.title": "クレジットを使い切りました",
  "paywall.reason.credits.body":
    "次のカバーが待っています。Basicなら作成数に上限がないので、もうクレジットを気にする必要はありません。",
  "paywall.reason.words.title": "好きな言葉をボイスにしゃべらせよう",
  "paywall.reason.words.body":
    "言葉を入力したり、曲のイメージを書いたりすると、ボイスが歌ったりしゃべったりします。Basicから使えます。",
  "paywall.reason.video.title": "動画にしよう",
  "paywall.reason.video.body":
    "Marble Runと歌詞動画を、TikTokやリール向けに。Creatorなら毎月50枚の動画コインが付きます。",
  "paywall.reason.resume.title": "続きから再開",
  "paywall.reason.resume.body":
    "選んだプランは保存されています。お支払いを済ませれば、好きなだけカバーを作れます。",
  "paywall.reason.train.title": "あなただけのボイスを作ろう",
  "paywall.reason.train.body":
    "少しの音声サンプルから自分のボイスを学習させて、どのカバーにも使えます。Creatorなら無制限です。",

  "paywall.cta.unlockFor": "{price}でカバーのロックを解除",
  "paywall.cta.keepGoingFor": "{price}で続ける",
  "paywall.cta.backToCreatorFor": "{price}でCreatorに戻る",
  "paywall.cta.backFor": "{price}で再開する",
  "paywall.cta.startFor": "{price}で始める",
  "paywall.cta.startPlanFor": "{price}で{plan}を始める",

  "paywall.renew.welcome":
    "継続している限り月額{price}。解約するまで毎月自動で更新されます。",
  "paywall.renew.then":
    "以降は月額{price}。解約するまで毎月自動で更新されます。",
  "paywall.renew.yearly":
    "本日12か月分の{price}をお支払い。解約するまで毎年自動で更新されます。",

  "paywall.toast.updated": "サブスクリプションを更新しました！",
  "paywall.toast.error": "エラーが発生しました。もう一度お試しください。",

  "paywall.welcomeBack": "おかえりなさい",
  "paywall.priceMonth": "月額{price}",
  "paywall.welcome.offerCreator": "Creatorを月額{price}",
  "paywall.welcome.card":
    "プランが停止したのは、お支払いが完了しなかったためで、解約されたわけではありません。{offer}で続きから再開できます。",
  "paywall.welcome.price":
    "料金が高いとのご意見をいただいたので、お安くしました。継続している限り、{was}のところ{offer}でご利用いただけます。",
  "paywall.welcome.broken":
    "うまく動かないとのご意見をいただきました。直近1週間では、カバー100件中{n}件が問題なく完成しています。{offer}で戻ってきませんか。",
  "paywall.welcome.secretCreator":
    "公開していない特別プランで、Creatorを月額{price}。登録を続けている限り、この料金のままです。",
  "paywall.welcome.secret":
    "以前と同じ機能をすべて、公開していない特別プランで月額{price}。登録を続けている限り、この料金のままです。",
  "paywall.welcome.coversHere": "あなたの{n}曲のカバーはそのまま残っています",
  "paywall.welcome.coverHere": "あなたのカバーはそのまま残っています",
  "paywall.welcome.makeAgain": "またカバーを作る",
  "paywall.ended.today": "プランは本日終了しました",
  "paywall.ended.yesterday": "プランは昨日終了しました",
  "paywall.ended.days": "プランは{n}日前に終了しました",
  "paywall.ended.months": "プランは{n}か月前に終了しました",
  "paywall.more": "その他",

  "paywall.recommended": "おすすめ",
  "paywall.perMonth": "/月",
  "paywall.perMonthStay": "/月（継続中はずっとこの料金）",
  "paywall.firstMonth": "初月",
  "paywall.today": "本日",
  "paywall.heldFor": "残り{time}保存",
  "paywall.coverReady": "カバーを作る準備ができました",
  "paywall.coverSetUp": "音声とボイスの設定が完了しています",
  "paywall.coversToday": "今日Jammableで作られたカバー：{n}曲",
  "paywall.coversTodayShort": "今日作られたカバー：{n}曲",
  "paywall.pickPlanUnlock": "プランを選んでロックを解除",
  "paywall.pickPlan": "プランを選ぶ",
  "paywall.whatYouGet": "{plan}でできること",
  "paywall.secure": "Stripeによる安全なお支払い・いつでも解約OK",
  "paywall.topPlan": "最上位プランをご利用中です",
  "paywall.managePlan": "プランを管理",

  "paywall.changePlan": "プランを変更",
  "paywall.planYearly": "{plan}（年額）",
  "paywall.planMonthly": "{plan}プラン",
  "paywall.billedYearly": "年払い",
  "paywall.pay": "支払う",
  "paywall.payUnlock": "支払ってロックを解除",
  "paywall.checkoutLoading": "お支払い画面を準備しています",

  "paywall.leave.title": "カバーを作らずに離れますか？",
  "paywall.leave.oneStep": "あと一歩です。",
  "paywall.leave.audioIn": "音声は追加済み",
  "paywall.leave.voiceReady": "{names}が歌う準備をしています",
  "paywall.leave.voicesReady": "{names}が歌う準備をしています",
  "paywall.leave.voicePicked": "ボイスは選択済み",
  "paywall.leave.makeStep": "カバーを作成：約1分",
  "paywall.leave.gets": "ロックを解除すると",
  "paywall.leave.held":
    "残り{time}保存されます。それを過ぎると消えてしまい、もう一度作り直す必要があります。",
  "paywall.unlockMyCover": "カバーのロックを解除",
  "paywall.leaveAnyway": "それでも離れる",

  "paywall.gift.wrapping": "プレゼントを用意しています…",
  "paywall.gift.beforeYouGo": "お帰りの前に",
  "paywall.gift.saved": "プレゼントをご用意しました",
  "paywall.gift.openToSee": "開けて中身を確かめてください。",
  "paywall.gift.opening": "開けています…",
  "paywall.gift.open": "プレゼントを開ける",
  "paywall.gift.noThanks": "いりません、離れる",
  "paywall.gift.yours": "あなたへのプレゼント",
  "paywall.gift.headline": "{plan}が月額{price}",
  "paywall.gift.body":
    "すべてのボイスでカバー作成が無制限。12か月間この料金で固定されます。",
  "paywall.gift.save": "{pct}%オフ",
  "paywall.perMo": "/月",
  "paywall.gift.billedYearly": "年額{price}のお支払い",
  "paywall.gift.lockIn": "月額{price}で確定する",
  "paywall.seeMonthly": "月額プランを見る",

  "paywall.locked.step.upload": "音声をアップロード中",
  "paywall.locked.step.match": "ボイスを合わせています",
  "paywall.locked.step.mix": "ミックスを準備中",
  "paywall.locked.yourAudio": "あなたの音声",
  "paywall.locked.yourAiSong": "あなたのAIソング",
  "paywall.locked.yourWords": "あなたのテキスト",
  "paywall.locked.yourVoice": "あなたのボイス",
  "paywall.locked.startFailed":
    "カバーを開始できませんでした。もう一度お試しください。",
  "paywall.locked.makeNow": "今すぐ作成",
  "paywall.unlock": "ロックを解除",
  "paywall.locked.pctDone": "{pct}%完了",
  "paywall.locked.gettingReady": "{names}で{song}を準備しています",
  "paywall.locked.done": "完了",
  "paywall.locked.now": "処理中",
  "paywall.locked.expired": "このカバーは期限切れです",
  "paywall.locked.expiredBody":
    "ロック中のカバーの保存期間は48時間です。1分ほどで作り直せます。",
  "paywall.locked.makeAgain": "もう一度作る",
  "paywall.locked.readyToMake": "作成の準備完了",
  "paywall.locked.readyOne": "{names}のAIボイスで{song}を歌う準備ができました",
  "paywall.locked.readyMany": "{names}のAIボイスで{song}を歌う準備ができました",
  "paywall.locked.onPlan":
    "プランにご登録済みなので、今すぐ作成を始められます。約1分で完成します。",
  "paywall.locked.unlockBody":
    "ロックを解除するとすぐにカバーの作成が始まります。約1分で完成し、ダウンロードやシェアができます。",
  "paywall.locked.change": "ボイスや音声を変更",
  "paywall.locked.notMade": "このカバーはまだ作成されていません",
  "paywall.locked.makeYourOwn": "{names}で約1分、自分のカバーを作ろう。",
  "paywall.locked.makeCover": "カバーを作成",

  "paywall.video.unlock": "カバーと動画の\nロックを解除",
  "paywall.video.howItLooks": "動画はこのように仕上がります",
  "paywall.video.drawing": "動画を描画しています",
  "paywall.video.aria": "{cta}：カバーとその動画",

  "paywall.return.firstMonth": "初月{price}",
  "paywall.return.waiting": "{title}のカバーが待っています",
  "paywall.return.savedWaiting": "保存したカバーが待っています",
  "paywall.return.trialReady": "7日間の無料トライアルを開始できます",
  "paywall.return.trialDetail":
    "本日のお支払いはなし、以降は月額{price}。いつでも解約できます。",
  "paywall.return.startTrial": "無料トライアルを開始",
  "paywall.return.funds":
    "カードの残高が不足しているとカード会社から連絡がありました。",
  "paywall.return.declined": "カード会社に承認されませんでした。",
  "paywall.return.cardFailed": "カードのお支払いが完了しませんでした",
  "paywall.return.cardDetail":
    "カードのお支払いが完了しませんでした。Apple Pay、Google Pay、または別のカードをお試しください・{price}",
  "paywall.return.whyDetail":
    "{why}Apple Pay、Google Pay、または別のカードをお試しください・{price}",
  "paywall.return.tryAnother": "別の方法を試す",
  "paywall.return.confirm": "カード会社による簡単な確認が必要です",
  "paywall.return.confirmDetail": "あと1ステップで完了です・{price}",
  "paywall.return.finish": "お支払いを完了する",
  "paywall.return.planHere": "{plan}プランはまだ保存されています",
  "paywall.return.heldMore": "残り{time}保存・{price}",
  "paywall.return.thenRegular": "{price}、以降は{regular}",
  "paywall.return.cancelAny": "{price}、いつでも解約OK",
  "paywall.return.pickUp": "続きから再開する",
  "paywall.return.cardStopped":
    "お支払いが完了しなかったため、プランが停止しました",
  "paywall.return.comeBack": "Jammableに戻る",
  "paywall.return.pickUpFor": "{offer}で続きから再開できます。",
  "paywall.return.secretOffer":
    "公開していない特別プランで、{offer}で戻ってきませんか。",
  "paywall.return.hide": "非表示",
};

export default paywall;
